import React from 'react';
import properties from '../../../constants/Properties';
import audioEditorUtils from '../utils/AudioEditorUtils';
import mouseUtils from '../../utils/MouseUtils';
import playController from '../../utils/PlayController';
import { setMarkerPosition } from '../../../actions/AudioEditorActions';
import audioToolUtils from '../../audioTool/utils/AudioToolUtils';

export const Ruler = React.createClass({
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (playController.isPlaying)
            return;

        var localX = e.nativeEvent.offsetX;

        if (e.nativeEvent.touches && e.nativeEvent.touches.length > 0)
            localX = e.nativeEvent.touches[0].clientX - audioToolUtils.buttonsHolderWidth() + playController.getIpadScrollPosition();

        var markerPosition = audioEditorUtils.getItemTimePosition(localX);
        playController.playSlidesSequence(false, markerPosition);

        this.props.dispatch(setMarkerPosition(markerPosition));
    },
    hasMinValue() {
        if (audioEditorUtils.getZoomValue() < 0.4)
            return true;
        else
            return false;
    },
    render() {
        const rulerHeight = properties.RULER_HEIGHT;
        const listHeight = audioToolUtils.isAudioTool() ? properties.SLIDE_VIEWER_TOP_GAP * 5 : properties.SLIDE_VIEWER_LIST_HEIGHT + properties.SLIDE_VIEWER_TOP_GAP;
        const normalSlideViewerHeight = properties.SLIDE_VIEWER_TOP_LINE_HEIGHT + listHeight + properties.SLIDE_VIEWER_BOTTOM_GAP;

        var menuStyle = {
            position: 'absolute',
            cursor: 'default',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            top: normalSlideViewerHeight - rulerHeight,
            left: 0,
            width: this.props.width,
            height: rulerHeight
        };

        var isMinimized = this.hasMinValue();
        var steps = 10;

        if (isMinimized) {
            steps = 2;
        }

        const oneSecondWidth = audioEditorUtils.getSlideWidth(1);
        const lineSize = 1;
        const breakSize = (oneSecondWidth - steps * lineSize) / steps;
        const lineHeight = 5;
        const length = Math.ceil(this.props.width / (lineSize + breakSize));
        var i;
        var elements = [];
        var seconds = [];
        var counter = 0;

        for (i=0; i<length; i++) {
            var height = lineHeight;

            if (i % steps == 0) {

                // Set width and position of time indication
                var spanWidth = 30;
                var spanPositionTop = rulerHeight - lineHeight * 3 - 12;
                var spanPositionLeft = i * (lineSize + breakSize) - spanWidth / 2

                var spanStyle = {
                    position: 'absolute',
                    fontSize: 10,
                    fontWeight: 'bold',
                    height: 10,
                    width: spanWidth,
                    top: spanPositionTop,
                    left: spanPositionLeft,
                    color: 'black',
                    cursor: 'default',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    textAlign: 'center',
                    pointerEvents: 'none'
                };

                if (isMinimized) {
                    if (length - i > 2 && i % 10 == 0) {
                        seconds.push(<span style={spanStyle} key={'seconds' + counter}>{audioEditorUtils.transformToSeconds(counter)}</span>);
                        height = height * 3;
                    }
                } else {
                    if (length - i > 2) {
                        seconds.push(<span style={spanStyle} key={'seconds' + counter}>{audioEditorUtils.transformToSeconds(counter)}</span>);
                        height = height * 3;
                    }
                }

                counter = counter + 1;
            }

            // Dont render ticks for half seconds (shows 4 ticks instead of 9 between time indications on far zoom)
            if (isMinimized && i % steps !== 0)
                continue;

            var lineStyle = {
                position: 'absolute',
                width: lineSize,
                height: height,
                top: rulerHeight - height,
                left: i * (lineSize + breakSize),
                background: 'black',
                pointerEvents: 'none'
            };
            
            elements.push(<div style={lineStyle} key={'ruler' + i}/>);
        }

        return (
            <div style={menuStyle} onTouchStart={this.onClick} onMouseDown={this.onClick}>
                {elements}
                {seconds}
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/audioEditor/menus/Ruler.js
 **/